export default __webpack_public_path__ + "static/media/home_photo.10cfa9f1.jpg";